module.exports = {
	"appName": "CM",
	"modules": {
		"Login": "Login",
		"Workers": "Empleados",
		"WorkersNew": "Nuevo",
		"WorkersEdit": "Editar"
	},
	"worker": {
		"moduleName": "Empleados",
		"newWorker": "Nuevo",
		"list": "Lista",
		"new": "nuevo trabajador",
		"idNumber": "RUT",
		"firstName": "Nombre",
		"lastName": "Apellido",
		"email": "Correo electrónico",
		"phoneNumber": "Número de teléfono",
		"birthDate": "Fecha de nacimiento",
		"workerStatus": "Estado del trabajador",
		"name": "Nombre",
		"showAdvancedDetails": "Más información",
		"status": {
			"active": "Activo",
			"inactive": "Inactivo",
		}
	},
	"contract": {
		"title": "Contrato",
		"type": "Tipo",
		"startDate": "Fecha de inicio",
		"endDate": "Fecha de término",
		"salary": "Salario",
		"position": "Cargo"
	},
	"common": {
		"noDateSelected": "No se ha seleccionado fecha",
		"more": "Más",
		"less": "Menos",
		"open": "Abrir",
		"close": "Cerrar",
		"actions": "Actions",
		"search": "Buscar"
	},
	"buttons": {
		"save": "Guardar",
		"cancel": "Cancelar",
		"today": "Hoy",
		"reset": "Reiniciar",
		"close": "Cerrar"
	},
	"datepicker": {
		"arrowKeys": "Usar flechas para moverse por las fechas",
		"labelPrevDecade": "Década anterior",
		"labelPrevYear": "Año anterior",
		"labelPrevMonth": "Mes anterior",
		"labelCurrentMonth": "Mes actual",
		"labelNextMonth": "Mes siguiente",
		"labelNextYear": "Año siguiente",
		"labelNextDecade": "Década siguiente",
	}
}